import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_CREATE_SIZE,
  ROLE_EDIT_SIZE,
  ROLE_SHOW_SIZE,
} from 'helpers/roles';

import List from './List';
import Form from './Form';

const Diets = props => {
  const { match, history } = props;
  const ListSecured = withRole(ROLE_SHOW_SIZE, List);
  const CreateForm = withRole(ROLE_CREATE_SIZE, Form);
  const EditForm = withRole(ROLE_EDIT_SIZE, Form);

  return (
    <DataGridStateContextProvider>
      <Router history={history}>
        <Switch>
          <Route
            exact={true}
            path={`${match.url}/`}
            render={parentProps => <ListSecured {...props} {...parentProps} />}
          />
          <Route
            path={`${match.url}/add`}
            render={() => <CreateForm {...props} />}
          />
          <Route
            path={`${match.url}/edit/:id`}
            render={parentProps => <EditForm {...props} {...parentProps} />}
          />
        </Switch>
      </Router>
    </DataGridStateContextProvider>
  );
};

export default withRouter(Diets);
